function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Skeleton, Alert, Button } from 'antd';
import Common from "../components/includes/Common";
import TicketViewCardHorizontal from "../components/TicketViewCardHorizontal";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { useParams } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TicketsPage = function TicketsPage() {
  var ref = useRef();
  var _useParams = useParams(),
    orderid = _useParams.orderid;
  var _useParams2 = useParams(),
    detail = _useParams2.detail;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    feed = _useState2[0],
    setFeed = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isFeedLoading = _useState4[0],
    setIsFeedLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  useEffect(function () {
    if (orderid == null || detail == null) {
      setErrorMessage("Données incomplètes ...");
      return;
    }
    setIsFeedLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getorder/").concat(orderid, "/").concat(detail)).then(function (response) {
      setFeed(response.data.tickets);
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFeedLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 10,
          children: [/*#__PURE__*/_jsx(Alert, {
            type: "warning",
            showIcon: true,
            banner: true,
            message: "Sur mobile, mettez votre t\xE9l\xE9phone en mode paysage pour une meilleure vue!",
            action: /*#__PURE__*/_jsx(ReactToPrint, {
              content: function content() {
                return ref.current;
              },
              children: /*#__PURE__*/_jsx(PrintContextConsumer, {
                children: function children(_ref) {
                  var handlePrint = _ref.handlePrint;
                  return /*#__PURE__*/_jsx(Button, {
                    ghost: true,
                    danger: true,
                    onClick: handlePrint,
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Sauvegarder"
                    })
                  });
                }
              })
            })
          }), /*#__PURE__*/_jsxs("div", {
            id: "printable",
            ref: ref,
            style: {
              minHeight: '300px'
            },
            children: [feed.map(function (f) {
              return /*#__PURE__*/_jsx(TicketViewCardHorizontal, {
                ticket: f
              }, f.id);
            }), !isFeedLoading && feed.length == 0 && /*#__PURE__*/_jsx("p", {
              children: "Vous n'avez aucun ticket"
            }), isFeedLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default TicketsPage;